<template>
  <Top>
    <div class="cell" v-if="!isV3LunGuanDevice">
      <van-cell
        is-link
        :border="true"
        title="分组"
        @click="handleClick('/groupList')"
      />
      <van-cell
        is-link
        :border="true"
        title="轮灌程序"
        @click="handleClick('/programList')"
      />
    </div>

    <div class="" v-else>
      <van-cell is-link :border="true" title="分组" @click="handleGoGroup" />

      <van-collapse v-model="active" accordion @change="handleCollapseChage">
        <van-collapse-item title="轮灌程序" name="1">
          <div v-show="list.length">
            <div
              class="card"
              v-for="(item, index) in list"
              :key="index"
              @click="handleClick('/programList3', item)"
            >
              <div class="row row1">
                <span class="name"
                  >{{ item.index + 1 }}号程序
                  <span
                    style="display:flex; align-items: center; margin-left:10px;"
                  >
                    {{ item.proName }}
                    <van-icon
                      @click.stop.prevent="handleClickChangeName(index)"
                      name="edit"
                      :style="{ marginLeft: '10px', fontSize: '26px' }"
                    />
                  </span>
                </span>
                <span
                  :class="[
                    'tag',
                    item.sta === 1
                      ? 'working'
                      : item.sta === 2
                      ? 'stopping'
                      : 'noworking'
                  ]"
                  >{{
                    item.sta === 1
                      ? "灌溉中"
                      : item.sta === 2
                      ? "暂停中"
                      : "未开启"
                  }}</span
                >
              </div>
              <div
                class="row row2 time"
                v-show="item.sta === 1 || item.sta === 2"
              >
                运行时长 - {{ item.minute }}分钟
              </div>
              <div class="row row2" v-show="item.sta === 1 || item.sta === 2">
                <span class="iconfont icon-naozhong"></span>&nbsp;&nbsp;
                <span>开启时间 - </span>&nbsp;&nbsp;
                <span class="open-time">{{ item.start_t }}</span>
              </div>
              <div class="row row3">
                <span class="iconfont icon-list"></span>&nbsp;&nbsp;
                <span v-if="item.sta === 1 || item.sta === 2">
                  {{ item.sta === 1 ? "正在执行" : "执行到" }} - 第{{
                    item.group + 1
                  }}组（共{{ item.total_group }}组）&nbsp;{{ item.group_time }}
                </span>
                <span v-else>共{{ item.total_group }}组</span>
              </div>
            </div>
          </div>
          <div v-show="!list.length">
            <pageToast ref="pageToast" />
          </div>
        </van-collapse-item>
      </van-collapse>
    </div>
    <van-dialog
      v-model="visible"
      title="修改设备名称"
      show-cancel-button
      @confirm="handleChangeName"
      @cancel="() => (visible = false)"
    >
      <van-field
        v-model.trim="newDeviceName"
        placeholder="请输入新的设备名称"
        maxlength="50"
        type="textarea"
        show-word-limit
      />
    </van-dialog>
  </Top>
</template>

<script>
import Top from "./top.vue";

export default {
  components: {
    Top
  },
  data() {
    const no = localStorage.getItem("no");
    const deviceType = sessionStorage.getItem("deviceType");
    return {
      active: "1",
      no,
      list: [],
      type: deviceType,
      visible: false,
      newDeviceName: null,
      changeDeviceIndex: null,
      isV3LunGuanDevice:
        deviceType == 17 ||
        deviceType == 18 ||
        deviceType == 23 ||
        deviceType == 24 // 设备类型  17 18 23 表示 轮灌组v3 设备
    };
  },
  mounted() {
    console.log("lunguan1111");

    this.isV3LunGuanDevice && this.getData();
  },

  methods: {
    handleClick(route, data) {
      console.log("data:", data);
      this.$router.push({
        path: route,
        query: {
          data: data ? JSON.stringify(data) : undefined
        }
      });
    },

    async handleCollapseChage(val) {
      console.log("切换面板：", val);
      // 刷新程序列表
      val && this.getData();
    },

    async getData() {
      await this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0
      });
      await this.$api.lgV2_getProgram_list(this.no).then(res => {
        if (res.errcode === 0) {
          const data = res.data;
          data.map(item => {
            item.minute = (item.run_t / 60).toFixed(2);
            item.group_time = this.getTime(item.group_t, 2);
          });

          this.list = [...data];

          // run_t -> minute 秒转分钟
          // group_t -> group_time 秒转 mm:ss

          if (!this.list.length) {
            this.$refs.pageToast && (this.$refs.pageToast.type = 1);
          } else {
            this.$refs.pageToast && (this.$refs.pageToast.type = 0);
          }
        } else {
          this.$toast({
            message: "查询程序列表异常:" + res.errmsg
          });

          this.$refs.pageToast && (this.$refs.pageToast.type = 1);
        }
      });

      setTimeout(() => {
        this.$toast.clear();
      }, 1500);
    },

    getTime(second = 0, type = 1) {
      second = Number(second);
      let h = 0,
        m = 0,
        s = 0;

      const u_h = 60 * 60;
      const u_m = 60;

      h = Math.floor(second / u_h);
      m = Math.floor((second - h * u_h) / u_m);
      s = second - h * u_h - m * u_m;

      const M = String(m).padStart(2, "0");
      const S = String(s).padStart(2, "0");

      if (type === 1) {
        if (h) {
          const H = String(h).padStart(2, "0");
          return `${H}:${M}:${S}`;
        }
      }

      return `${M}:${S}`;
    },

    // 去设置分组
    handleGoGroup(data) {
      this.$router.push({
        // 23 园林控制器
        path:
          this.type == 23 || this.type == 24 ? "/groupList4" : "/groupList3",
        query: {
          data: JSON.stringify(data)
        }
      });
    },

    handleClickChangeName(index) {
      this.changeDeviceIndex = index;
      this.visible = true;
      const arr = this.list[index].groupName?.split(" ");

      console.log("arr:", arr);
      this.newDeviceName = this.list[index].proName;
    },

    handleChangeName() {
      console.log("修改设备的名称");
      console.log("this.newDeviceName:", this.newDeviceName);

      if (!this.newDeviceName) return this.$toast("程序名称不能为空");

      if (this.newDeviceName === this.list[this.changeDeviceIndex].proName) {
        this.visible = false;
        return;
      }

      this.$api
        .lgV2_setProgram_name({
          gatewayNo: this.no,
          proId: this.list[this.changeDeviceIndex].index,
          proName: this.newDeviceName
        })
        .then(res => {
          if (res.errcode === 0) {
            this.newDeviceName = null;
            this.changeDeviceIndex = -1;
            this.$toast({
              message: "设置成功",
              duration: 3000
            });
            setTimeout(() => {
              this.getData();
            }, 3000);
          } else {
            this.$toast("设置程序名称异常：" + (res.errmsg ?? ""));
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  border-bottom: 0.5px solid #e8e8e8;
  margin-bottom: 20px;
  padding-bottom: 7px;

  &:last-child {
    padding-bottom: 0;
    margin-bottom: 0;
    border: none;
  }

  .row {
    display: flex;
    align-items: center;
    margin-bottom: 4px;

    &:last-child {
      margin-bottom: 0;
    }

    .iconfont {
      margin-right: 5px;
      color: #000000;
      font-size: 20px;
    }
  }

  .row1 {
    .name {
      display: flex;
      align-items: center;
      color: #464646;
      font-weight: bold;
      font-size: 16px;
    }

    .tag {
      width: 48px;
      border-radius: 10px;
      padding: 0px 10px;
      font-size: 12px;
      margin-left: 20px;
    }

    .working {
      background: rgba(27, 224, 141, 0.15);
      color: #29bc7e;
    }

    .noworking {
      background: #fcf3eb;
      color: #edb077;
    }

    .stopping {
      color: #cf1322;
      background: #fff1f0;
    }

    .time {
      color: #464646;
      font-size: 12px;
      margin-left: 16px;
    }
  }

  .open-time {
    margin-left: 5px;
  }

  .row2 {
  }
}

.card {
  border-bottom: 0.5px solid #e8e8e8;
  margin-bottom: 20px;
  padding-bottom: 7px;

  &:last-child {
    padding-bottom: 0;
    margin-bottom: 0;
    border: none;
  }

  .row {
    display: flex;
    align-items: center;
    margin-bottom: 4px;

    &:last-child {
      margin-bottom: 0;
    }

    .iconfont {
      margin-right: 5px;
      color: #000000;
      font-size: 20px;
    }
  }

  .row1 {
    .name {
      color: #464646;
      font-weight: bold;
      font-size: 16px;
    }

    .tag {
      border-radius: 10px;
      padding: 0px 10px;
      font-size: 12px;
      margin-left: 20px;
    }

    .working {
      background: rgba(27, 224, 141, 0.15);
      color: #29bc7e;
    }

    .noworking {
      background: #fcf3eb;
      color: #edb077;
    }

    .time {
      color: #464646;
      font-size: 12px;
      margin-left: 16px;
    }
  }

  .open-time {
    margin-left: 5px;
  }
}
</style>
